import { render, staticRenderFns } from "./PlayerDetail.vue?vue&type=template&id=2a70b01f&"
import script from "./PlayerDetail.vue?vue&type=script&lang=js&"
export * from "./PlayerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports